module.exports = __webpack_public_path__ + "assets/img/call.4e9cedfe.svg";